import { IncubetaClickToCallEvents } from "./clickToCallEvents";

interface Window {
  dataLayer: any;
}

class IncubetaTagging {
  private isApexOpen: boolean = false;

  // create member that holds the function reference
  protected dynamicClickEventListener: EventListener;

  public constructor() {
    this.initialize();
  }

  private initialize() {
    this.dynamicClickEventListener = (e: Event) =>
      this.handleDynamicHandlers(e);

    new IncubetaClickToCallEvents();
    this.clickEvents();

    document.addEventListener("do.vehicleloadend", () => {
      const newElements = document.querySelectorAll("[data-tagging-event]");
      newElements.forEach((elem) => {
        this.attachEventListenerToElement(elem);
      });
    });
  }

  private attachEventListenerToElement(elem) {
    if (elem) {
      if (!("eventListenerAttached" in elem.dataset)) {
        elem.dataset.eventListenerAttached = "true";
        this.attachEventListener(elem);
      }
    }
  }

  private attachEventListener(elem) {
    if (elem) {
      elem.addEventListener("click", () => {
        this.parseTaggingEvents(elem);
      });
    }
  }

  private clickEvents() {
    const taggingData = document.querySelectorAll("[data-tagging-event]");
    if (taggingData) {
      taggingData.forEach((elem: HTMLElement) => {
        this.attachEventListenerToElement(elem);
      });
    }
  }

  private parseTaggingEvents(elem: HTMLElement) {
    let taggingEvent: string = null;

    //check for apex exit
    if (elem.innerText?.toLowerCase().trim() === "exit") {
      this.isApexOpen = false;
      taggingEvent = "exit";
      document.body.removeEventListener(
        "click",
        this.dynamicClickEventListener,
        true
      );
    } else {
      //account for child elements that were clicked and look up the tagging data
      taggingEvent = elem.dataset?.taggingEvent;
      if (!taggingEvent) {
        const ancestorEventData = elem.closest(
          "[data-tagging-event]"
        ) as HTMLElement;
        if (ancestorEventData) {
          taggingEvent = ancestorEventData.dataset.taggingEvent.toLowerCase();
        }
      }
    }

    if (!taggingEvent) {
      console.warn("Tagging event not supported for Incubeta.");
      return;
    }

    if (this.isApexOpen) {
      this.updateDataLayer({
        event: "digital_retail_step",
        step_name: `${taggingEvent}`,
      });
    } else {
      switch (taggingEvent) {
        case "srp":
        case "vdp":
        case "click":
          this.handleVehiclePageTaggingEvents(elem);
          break;
        default:
          return;
      }
    }
  }

  private handleVehiclePageTaggingEvents(elem) {
    if (elem.dataset?.taggingProducttype) {
      const productType = elem.dataset.taggingProducttype.toLowerCase();

      switch (productType) {
        case "apex widget launch":
          this.isApexOpen = true;
          //apex elements don't exist until we open it, so we have to use the body.
          //making sure we double check on the removal of these clicks to make sure we
          // aren't doubling up on events because sometimes APEX can error out and close
          // without us knowing about it.
          document.body.removeEventListener(
            "click",
            this.dynamicClickEventListener,
            true
          );
          document.body.addEventListener(
            "click",
            this.dynamicClickEventListener,
            true
          );

          this.updateDataLayer({
            event: "digital_retail_step",
            step_name: "start",
          });
          break;

        case "pricestack":
          this.handlePriceStackTaggingEvents(elem.dataset);
          break;

        default:
          console.warn(
            `Tagging for product "${productType}" is not supported.`
          );
      }
    }
  }

  private handlePriceStackTaggingEvents(dataset: any) {
    const taggingValue = dataset.taggingValue?.toLowerCase();
    if (taggingValue === "buy online") {
      const vehicleType = dataset.taggingAdditionalData ?? "";
      this.updateDataLayer({
        event: `buy_online_${vehicleType}_vehicle`,
      });
    } else {
      console.warn(`Tagging for ${taggingValue} not implemented.`);
    }
  }

  private handleDynamicHandlers(event: Event) {
    const elem = event.target as HTMLElement;
    this.parseTaggingEvents(elem);
  }

  private updateDataLayer(obj: object) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(obj);
  }
}

DoUtility.SelfInstantiateOnLoad(IncubetaTagging);
